import clx from 'classnames';

const SearchButton = ({ isLoading }: { isLoading?: boolean }) => (
  <button
    className="bg-neutral-500 hover:bg-neutral-700 focus:bg-neutral-600 transition clickable text-neutral-50 sm-regular px-3 py-1.5"
    data-testid="search"
    type="submit"
  >
    <i className={clx('fa-solid', isLoading ? 'animate-spin fa-circle-notch ' : 'fa-search')} />
  </button>
);
export default SearchButton;
